

document.addEventListener('DOMContentLoaded', function() {
   const filterButtons = document.querySelectorAll('[data-filter]');
   const productItems = document.querySelectorAll('.product-item');
   
   filterButtons.forEach(button => {
      button.addEventListener('click', function() {
         const filterType = this.dataset.filter;
         
         // toggle  class from all buttons
         filterButtons.forEach(btn => {
            btn.classList.remove('bg-black', 'text-white');
            btn.classList.add('bg-grey-lighter', 'text-black', 'hover:bg-grey');
         });
         
         // Add active class to clicked button
         this.classList.remove('bg-grey-lighter', 'text-black', 'hover:bg-grey');
         this.classList.add('bg-black', 'text-white');
         
         productItems.forEach(item => {
            let shouldShow = false;
            
            switch(filterType) {
               case 'all':
                  shouldShow = true;
                  break;
               case 'Refills':
                  shouldShow = item.dataset.type === 'Refills';
                  break;
               case 'sale':
                  shouldShow = item.dataset.isSale === 'true';
                  break;
               case 'starter-kit':
                  shouldShow = item.dataset.isStarterKit === 'true';
                  break;
            }
            
            item.style.display = shouldShow ? 'block' : 'none';
         });
      });
   });
});


// document.addEventListener('DOMContentLoaded', () => {
//   const categoryFilters = document.querySelectorAll('.category-filter');
//   const productGrid = document.querySelector('.grid');
//   const products = document.querySelectorAll('.grid > div');

//   if (categoryFilters.length > 0) {
//     let activeCategory = null;

//     categoryFilters.forEach(filter => {
//       filter.addEventListener('click', () => {
//         const category = filter.dataset.category;
        
//         // Toggle active state
//         if (activeCategory === category) {
//           // Remove active state
//           activeCategory = null;
//           filter.classList.remove('bg-grey');
//           filter.classList.add('bg-grey-lighter');
//         } else {
//           // Set new active state
//           activeCategory = category;
//           categoryFilters.forEach(f => {
//             f.classList.remove('bg-grey');
//             f.classList.add('bg-grey-lighter');
//           });
//           filter.classList.remove('bg-grey-lighter');
//           filter.classList.add('bg-grey');
//         }

//         // Filter products
//         products.forEach(product => {
//           const productCategory = product.dataset.category;
//           if (!activeCategory || productCategory === activeCategory) {
//             product.style.display = 'block';
//           } else {
//             product.style.display = 'none';
//           }
//         });
//       });
//     });
//   }
// }); 

